import styled from "styled-components/macro";

export const DataTour = styled.span.attrs(({ dataTour }) => ({
  "data-tour": dataTour,
}))`
  all: unset;
  display: contents;
`;
